import React from "react";

import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import {TextField} from "@mui/material";
import {INDETERMINATE} from "./usePriceSummarizer";


const TabMinNights = ({formik, height = 475}) => {

    return <Stack direction="column" spacing={4} mt={2} height={height}>
        <Typography>
            Configura il numero minimo di notti. Se una richiesta di prenotazione ha meno
            notti di quelle indicate di seguito, la richiesta di prenotazione sarà scartata.
        </Typography>

        <TextField type="number"
                   label="Numero minimo notti"
                   fullWidth
                   name="minNights"
                   required
                   value={formik.values.minNights === INDETERMINATE ? "" : formik.values.minNights || ""}
                   onChange={formik.handleChange}
                   error={formik.touched.minNights && Boolean(formik.errors.minNights)}
                   helperText={formik.touched.minNights && formik.errors.minNights}/>
    </Stack>
}

export default TabMinNights;